import loadable from '@loadable/component';

export const ComparisonNotificationContainerLoadable = loadable(() => import('./ComparisonNotificationContainer'), {
  resolveComponent: ({ ComparisonNotificationContainer }) => ComparisonNotificationContainer,
});
